import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import publicService from "../services/PublicService";

export const fetchInternships = createAsyncThunk(
  'internships/fetchInternships',
  async (_, { getState, rejectWithValue }) => {
    const { internshipsListPublic } = getState(); // Fixed: correct state name

    if (internshipsListPublic.items?.length > 0) {
      return rejectWithValue('Already have data');
    }
    
    try {
      const response = await publicService.internships.getInternships();
      return response
    } catch (error) {
      return rejectWithValue(error.message || error.response?.data?.message || 'Something went wrong');
    }
  }
);

const internshipSlice = createSlice({
  name: 'InternshipsListPublic',
  initialState: {
    items: [],       
    loading: false,
    error: null,
  },
  reducers: {
    clearInternshipsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInternships.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInternships.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchInternships.rejected, (state, action) => {
        state.loading = false;
        if (action.payload !== 'Already have data') {
          state.error = action.payload;
        }
      });
  },
});

export const { clearInternshipsError } = internshipSlice.actions;
export default internshipSlice.reducer;
